export const logging = {
  log: (...args) => {
    if (process.env.REACT_APP_IS_PROD !== 'true') {
      console.log(...args)
    }
  }
}